import { useEffect } from "react";

const DEFAULT_FAVICON = "/5XLogo.png";

/**
 * Swap the document favicon to the tenant logo when available.
 */
export function useTenantFavicon(logoUrl) {
  useEffect(() => {
    const href = logoUrl || DEFAULT_FAVICON;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    const previous = link.getAttribute("href");
    link.setAttribute("href", href);

    let apple = document.querySelector("link[rel='apple-touch-icon']");
    if (!apple) {
      apple = document.createElement("link");
      apple.rel = "apple-touch-icon";
      document.head.appendChild(apple);
    }
    const previousApple = apple.getAttribute("href");
    apple.setAttribute("href", href);

    return () => {
      link.setAttribute("href", previous || DEFAULT_FAVICON);
      apple.setAttribute("href", previousApple || DEFAULT_FAVICON);
    };
  }, [logoUrl]);
}
